import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiLimitConfigGet } from '@/entities/limit-config/modules/api/limit-config';

export const useLimitConfig = () =>
  useFetch({
    api: () => apiLimitConfigGet(),
    keywords: queryKeys.limitConfig,
    staleTime: 60_000,
  });
